import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import Layout from "@/layout";

export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    meta: { allow: false },
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
        meta: { allow: false }
      }
    ]
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: { allow: false }
  },
  {
    path: "/ocr",
    component: () => import("@/views/ocrDiscern/newIndex"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/signLand", //批量签约落地页
    component: () => import("@/views/signLand/index"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/ocr_p", //api批量签约落地页
    component: () => import("@/views/signLand/ocr_p"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/faceLand", //人脸识别回调落地页
    component: () => import("@/views/face/faceLand"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/faceIdentify", //人脸识别
    component: () => import("@/views/face/faceIdentify"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/ocr-discern",
    component: () => import("@/views/ocrDiscern/index"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/wxBank",
    component: () => import("@/views/wxBank/index"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/wxBank/info",
    component: () => import("@/views/wxBank/info"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true,
    meta: { allow: true }
  },
  {
    path: "/",
    component: Layout,
    redirect: "/goIndex",
    hidden: false,
    meta: { allow: false },
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        hidden: false,
        meta: { title: "首页", icon: "a-shouye-weixuanzhong", allow: false }
      }
    ]
  },
  // 新业态合作
  {
    path: "/newBusiness",
    component: Layout,
    redirect: "/newBusiness/postManage",
    hidden: false,
    meta: {
      title: "新业态任务",
      icon: "eject-line",
      allow: false
    },
    children: [
      {
        path: "branchCompany",
        component: () => import("@/views/newBusiness/branchCompany/index"),
        name: "BranchCompany",
        hidden: false,
        meta: {
          title: "分公司管理",
          noCache: false,
          allow: false
        }
      },

      {
        path: "storeManage",
        component: () => import("@/views/newBusiness/storeManage/index"),
        name: "StoreManage",
        hidden: false,
        meta: {
          title: "门店管理",
          noCache: false,
          allow: false
        }
      },
      {
        path: "postManage",
        component: () => import("@/views/newBusiness/postManage/index"),
        name: "PostManage",
        hidden: false,
        meta: {
          title: "岗位管理",
          noCache: false,
          allow: false
        }
      },
      {
        path: "postManage/createPost",
        component: () => import("@/views/newBusiness/postManage/createPost"),
        name: "createPost",
        hidden: true,
        meta: {
          title: "创建岗位",
          allow: false,
          noCache: true,
          activeMenu: "/newBusiness/postManage"
        }
      },
      {
        path: "postManage/postDetails",
        component: () => import("@/views/newBusiness/postManage/postDetails"),
        name: "postDetails",
        hidden: true,
        meta: {
          title: "岗位详情",
          allow: false,
          noCache: true,
          activeMenu: "/newBusiness/postManage"
        }
      },
      {
        path: "taskManage",
        component: () => import("@/views/newBusiness/taskManage/index"),
        name: "TaskManage",
        hidden: false,
        meta: { title: "任务管理", icon: "", noCache: false, allow: false }
      },
      {
        path: "recruiting",
        component: () => import("@/views/newBusiness/recruiting/index"),
        name: "NewBusinessRecruiting",
        hidden: false,
        meta: { title: "招聘管理", noCache: false, allow: false }
      },
      {
        path: "settlementCenter",
        component: () => import("@/views/newBusiness/settlementCenter/index"),
        name: "SettlementCenter",
        hidden: false,
        meta: {
          title: "结算中心",
          noCache: true,
          allow: false
        }
      },
      {
        path: "warningManage",
        component: () => import("@/views/newBusiness/warningManage/index"),
        name: "WarningManage",
        hidden: false,
        meta: {
          title: "预警管理",
          noCache: true,
          allow: false
        }
      },
      {
        path: "scheduling",
        component: () => import("@/views/newBusiness/scheduling/index"),
        name: "Scheduling",
        hidden: false,
        meta: { title: "排班管理", icon: "", noCache: false, allow: false }
      },

      {
        path: "taskManage/add",
        component: () => import("@/views/newBusiness/taskManage/add"),
        name: "taskManageAdd",
        hidden: true,
        meta: { title: "创建任务", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      },
      {
        path: "taskManage/batchadd",
        component: () => import("@/views/newBusiness/taskManage/batchadd"),
        name: "taskManageBatchadd",
        hidden: true,
        meta: { title: "批量创建任务", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      },
      {
        path: "taskManage/manageDetail",
        component: () => import("@/views/newBusiness/taskManage/manageDetail"),
        name: "ManageDetail",
        hidden: true,
        meta: { title: "任务详情", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      },
      {
        path: "taskManage/workLoadVerification",
        component: () => import("@/views/newBusiness/workLoadVerification/index.vue"),
        name: "workLoadVerification",
        hidden: true,
        meta: { title: "工作量核定", activeMenu: "/newBusiness/taskManage", noCache: true, rank: "1.1", allow: false }
      },

      {
        path: "taskManage/attendanceManagement/:detailUserInfo/:taskPeriodNo",
        component: () => import("@/views/newBusiness/taskManage/attendanceManagement.vue"),
        name: "attendanceManagement",
        hidden: true,
        meta: { title: "考勤管理", activeMenu: "/newBusiness/taskManage", noCache: true, rank: "1.1", allow: false }
      },

      {
        path: "taskManage/checkAttendance/:detailUserInfo/:taskPeriodNo",
        component: () => import("@/views/newBusiness/taskManage/checkAttendance.vue"),
        name: "checkAttendance",
        hidden: true,
        meta: { title: "查看考勤", activeMenu: "/newBusiness/taskManage", noCache: true, rank: "1.1", allow: false }
      },

      {
        path: "recruiting/detail",
        component: () => import("@/views/newBusiness/recruiting/detail"),
        name: "newBusinessRecruitingDetail",
        hidden: true,
        meta: { title: "招聘详情", noCache: true, activeMenu: "/newBusiness/recruiting", allow: false }
      },
      {
        path: "recruiting/release",
        component: () => import("@/views/newBusiness/recruiting/release"),
        name: "newBusinessRecruitingRelease",
        hidden: true,
        meta: { title: "新建招聘", noCache: true, activeMenu: "/newBusiness/recruiting", allow: false }
      },
      {
        path: "recruiting/manage",
        component: () => import("@/views/newBusiness/recruiting/manage"),
        name: "newBusinessRecruitingManage",
        hidden: true,
        meta: { title: "应聘管理", noCache: false, activeMenu: "/newBusiness/recruiting", allow: false }
      },

      {
        path: "beisenSettlement",
        component: () => import("@/views/newBusiness/settlementCenter/beisenSettlement"),
        name: "beisenSettlement",
        hidden: true,
        meta: {
          title: "北森结算中心",
          activeMenu: "/newBusiness/settlementCenter",
          noCache: true,
          allow: false
        }
      },
      {
        path: "resignation",
        component: () => import("@/views/newBusiness/resignation/index"),
        name: "Resignation",
        hidden: false,
        meta: { title: "离职管理", icon: "", noCache: false, allow: false }
      },

      {
        path: "storeTransfer",
        component: () => import("@/views/newBusiness/storeTransfer/index"),
        name: "StoreTransfer",
        hidden: false,
        meta: { title: "调店记录", icon: "", noCache: false, allow: false }
      },
      {
        path: "checkAttendance",
        component: () => import("@/views/newBusiness/taskManage/checkAttendance.vue"),
        name: "checkAttendance",
        hidden: true,
        meta: { title: "查看考勤", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "attendanceReview",
        component: () => import("@/views/newBusiness/attendanceReview/index"),
        name: "AttendanceReview",
        hidden: false,
        meta: { title: "考勤异常审核", icon: "", noCache: true, allow: false }
      },
      {
        path: "taskManage/detail",
        component: () => import("@/views/newBusiness/taskManage/lookDetail"),
        name: "taskManageDetail",
        hidden: true,
        meta: { title: "任务详情", icon: "", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      },
      {
        path: "taskManage/attendanceInfo",
        component: () => import("@/views/newBusiness/taskManage/attendanceInfo"),
        name: "attendanceInfo",
        hidden: true,
        meta: { title: "考勤管理", icon: "", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      }
    ]
  },
  // new 派单 sendOrders
  {
    path: "/sendOrders",
    component: Layout,
    redirect: "/sendOrders/index",
    hidden: false,
    meta: {
      title: "派单任务",
      icon: "wallet-line",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/sendOrders/index"),
        name: "SendOrders",
        hidden: false,
        meta: {
          title: "派单任务",
          allow: false
        }
      },
      {
        path: "index/createTask",
        component: () => import("@/views/sendOrders/component/createTask"),
        name: "sendOrdersCreateTask",
        hidden: true,
        meta: {
          title: "创建任务",
          allow: false,
          activeMenu: "/sendOrders/index"
        }
      },
      {
        path: "index/assignTask",
        component: () => import("@/views/sendOrders/component/assignTask"),
        name: "sendOrdersAssignTask",
        hidden: true,
        meta: {
          title: "指派任务",
          allow: false,
          activeMenu: "/sendOrders/index"
        }
      },
      {
        path: "index/taskDetails",
        component: () => import("@/views/sendOrders/component/taskDetails"),
        name: "sendOrdersTaskDetails",
        hidden: true,
        meta: {
          title: "派单任务详情",
          allow: false,
          activeMenu: "/sendOrders/index"
        }
      },
      {
        path: "index/settlementDetails",
        component: () => import("@/views/sendOrders/component/settlementDetails"),
        name: "sendOrdersSettlementDetails",
        hidden: true,
        meta: {
          title: "派单结算管理",
          allow: false,
          activeMenu: "/sendOrders/index"
        }
      }
    ]
  },
  //常规任务
  {
    path: "/task",
    component: Layout,
    redirect: "/task/indexN",
    hidden: false,
    meta: {
      title: "常规任务",
      icon: "gallery-upload-line",
      allow: false
    },
    children: [
      {
        path: "indexN",
        component: () => import("@/views/task/indexN"),
        name: "DistributeLeaflets",
        hidden: false,
        meta: {
          title: "常规任务",
          allow: false
        }
      },
      {
        path: "indexN/detailN",
        component: () => import("@/views/task/detailN"),
        name: "distributeLeafletsDetailsN",
        hidden: true,
        meta: {
          title: "任务详情",
          activeMenu: "/task/indexN",
          allow: false
        }
      },
      {
        path: "indexN/publishTaskN",
        component: () => import("@/views/task/publishTaskN"),
        name: "publishTaskN",
        hidden: true,
        meta: { title: "发布任务", activeMenu: "/task/indexN", allow: false }
      }
    ]
  },
  //资金账户
  {
    path: "/finance",
    component: Layout,
    redirect: "/finance/index",
    hidden: false,
    meta: {
      title: "资金账户",
      icon: "chat-smile-2-line",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/finance/index"),
        name: "finance",
        hidden: false,
        meta: { title: "资金账户", icon: "", noCache: true, allow: false }
      }
    ]
  },
  //人员管理
  {
    path: "/flexibleuser",
    component: Layout,
    redirect: "/flexibleuser/index",
    hidden: false,
    meta: {
      title: "人员管理",
      icon: "wode-weixuanzhong",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/flexibleuser/index"),
        name: "User",
        hidden: false,
        meta: { title: "人员列表", noCache: false, allow: false }
      },
      {
        path: "index/detail",
        component: () => import("@/views/flexibleuser/detail"),
        name: "flexibleuserDetail",
        hidden: true,
        meta: {
          title: "人员详情",
          noCache: true,
          activeMenu: "/flexibleuser/index",
          allow: false
        }
      },
      {
        path: "index/taskList",
        component: () => import("@/views/flexibleuser/taskList"),
        name: "taskList",
        hidden: true,
        meta: { title: "任务列表", noCache: true, allow: false }
      },
      {
        path: "importRecord",
        component: () => import("@/views/flexibleuser/import"),
        name: "ImportRecord",
        hidden: false,
        meta: { title: "导入记录", noCache: true, allow: false }
      },
      {
        path: "importRecord/importDetail",
        component: () => import("@/views/flexibleuser/importDetail"),
        name: "flexibleuserImportDetail",
        hidden: true,
        meta: {
          title: "签约记录详情",
          icon: "guide",
          noCache: true,
          activeMenu: "/flexibleuser/importRecord",
          allow: false
        }
      },
      {
        path: "personPost",
        component: () => import("@/views/flexibleuser/personPost"),
        name: "PersonPost",
        hidden: false,
        meta: { title: "人岗合同", noCache: true, allow: true }
      },
      {
        path: "PersonCompany",
        component: () => import("@/views/flexibleuser/personCompany"),
        name: "PersonCompany",
        hidden: false,
        meta: { title: "人企合同", noCache: false, allow: true }
      }
    ]
  },
  // 批量发放
  {
    path: "/payment",
    component: Layout,
    redirect: "/payment/batchp",
    hidden: false,
    meta: {
      title: "批量发放",
      icon: "zhengshufafang",
      allow: false
    },
    children: [
      {
        path: "batchp",
        component: () => import("@/views/payment/batchpPayment"),
        name: "BatchpPayment",
        hidden: false,
        meta: { title: "批量发放", noCache: true, allow: false }
      },
      {
        path: "batchp/paymentEdit",
        component: () => import("@/views/payment/components/payment11"),
        name: "PaymentEdit",
        hidden: true,
        meta: {
          title: "校验编辑",
          activeMenu: "/payment/batchp",
          noCache: true,
          allow: false
        }
      }
    ]
  },
  // 发放明细
  {
    path: "/distribution",
    component: Layout,
    redirect: "/distribution/index",
    hidden: false,
    meta: {
      title: "发放明细",
      icon: "mingxi3",
      allow: false
    },
    children: [
      {
        path: "apiDistribution",
        component: () => import("@/views/distribution/ApiDetail"),
        name: "ApiDistribution",
        hidden: false,
        meta: { title: "批次订单", noCache: false, allow: false }
      },
      {
        path: "index",
        component: () => import("@/views/distribution/index"),
        name: "DistributionDetails",
        hidden: false,
        meta: { title: "交易明细", noCache: false, allow: false }
      }
    ]
  },
  //个税试算
  {
    path: "/tryBalance",
    component: Layout,
    redirect: "/tryBalance/tryData",
    hidden: false,
    meta: {
      title: "个税试算",
      icon: "gallery-upload-line",
      allow: false
    },
    children: [
      {
        path: "tryData",
        component: () => import("@/views/tryBalance/tryData"),
        name: "TryData",
        hidden: false,
        meta: { title: "试算导入", icon: "", noCache: false, allow: false }
      },
      {
        path: "tryData/tryDataDetail",
        component: () => import("@/views/tryBalance/tryDataDetail"),
        name: "TryDataDetail",
        hidden: true,
        meta: {
          title: "试算数据详情",
          activeMenu: "/tryBalance/tryData",
          allow: false,
          noCache: true
        }
      },
      {
        path: "tryList",
        component: () => import("@/views/tryBalance/tryList"),
        name: "TryList",
        hidden: false,
        meta: { title: "试算结果", icon: "", noCache: true, allow: false }
      },
      {
        path: "tryList/tryDetail",
        component: () => import("@/views/tryBalance/tryDetail"),
        name: "TryDetail",
        hidden: true,
        meta: { title: "试算详情", activeMenu: "/tryBalance/tryList", noCache: true, allow: false }
      }
    ]
  },
  // 开票管理
  {
    path: "/applyInvoicing",
    component: Layout,
    redirect: "/applyInvoicing/index",
    hidden: false,
    meta: {
      title: "开票管理",
      icon: "kaipiaowancheng",
      allow: false
    },
    children: [
      {
        path: "index/selectInvoice",
        component: () => import("@/views/applyInvoicing/selectInvoice"),
        name: "selectInvoice",
        hidden: true,
        meta: {
          title: "开票管理",
          icon: "",
          activeMenu: "/applyInvoicing/index",
          noCache: true,
          allow: false
        }
      },
      {
        path: "index",
        component: () => import("@/views/applyInvoicing/index"),
        name: "applyInvoicing",
        hidden: false,
        meta: {
          title: "开票管理",
          icon: "",
          activeMenu: "/applyInvoicing/index",
          noCache: true,
          allow: false
        }
      },
      {
        path: "index/invoicingEdit",
        component: () => import("@/views/applyInvoicing/invoicingEdit"),
        name: "invoicingEdit",
        hidden: true,
        meta: {
          title: "申请开票",
          icon: "",
          activeMenu: "/applyInvoicing/index",
          noCache: true,
          allow: false
        }
      },
      {
        path: "index/details",
        component: () => import("@/views/applyInvoicing/details"),
        name: "invoicingDetails",
        hidden: true,
        meta: {
          title: "发票详情",
          icon: "",
          activeMenu: "/applyInvoicing/index",
          noCache: true,
          allow: false
        }
      }
    ]
  },
  // 对账中心
  {
    path: "/center",
    component: Layout,
    redirect: "/center/moneyCenter",
    hidden: false,
    meta: {
      title: "对账中心",
      icon: "coins-line",
      allow: false
    },
    children: [
      {
        path: "moneyCenter",
        component: () => import("@/views/center/moneyCenter"),
        name: "MoneyCenter",
        hidden: false,
        meta: { title: "资金账单", noCache: true, allow: false }
      },
      {
        path: "serviceCenter",
        component: () => import("@/views/center/serviceCenter"),
        name: "ServiceCenter",
        hidden: false,
        meta: { title: "业务账单", noCache: true, allow: false }
      },
      {
        path: "busSettleForm",
        component: () => import("@/views/center/busSettleForm"),
        name: "BusSettleForm",
        hidden: false,
        meta: { title: "业务结算单", noCache: false, rank: "1.5", allow: false }
      },
      {
        path: "taxCertificateForm",
        component: () => import("@/views/center/taxCertificateForm"),
        name: "TaxCertificateForm",
        hidden: false,
        meta: { title: "完税证明", noCache: false, rank: "1.5", allow: false }
      }
    ]
  },
  // 企业信息
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile/index",
    hidden: false,
    meta: {
      title: "企业信息",
      icon: "qiye",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/profile/index"),
        name: "Profile",
        hidden: false,
        meta: { title: "商户信息", noCache: true, allow: false }
      },
      {
        path: "invoicing",
        component: () => import("@/views/profile/invoicing"),
        name: "invoicing",
        hidden: false,
        meta: { title: "开票信息", noCache: true, allow: false }
      },
      {
        path: "docking",
        component: () => import("@/views/profile/docking"),
        name: "docking",
        hidden: false,
        meta: { title: "API对接", noCache: true, allow: false }
      }
    ]
  },
  {
    path: "/system",
    component: Layout,
    redirect: "/system/userManage",
    hidden: false,
    meta: {
      title: "系统设置",
      icon: "shezhi",
      allow: false
    },
    children: [
      {
        path: "userManage",
        component: () => import("@/views/profile/userManage"),
        name: "UserManage",
        hidden: false,
        meta: { title: "用户管理", noCache: true, allow: false }
      },
      // {
      //   path: "loginLog",
      //   component: () => import("@/views/system/loginLog"),
      //   name: "LoginLog",
      //   hidden: false,
      //   meta: { title: "操作日志", noCache: false, rank: "1.1", allow: false }
      // },
      {
        path: "downloadCenter",
        component: () => import("@/views/download/downloadCenter"),
        name: "DownloadCenter",
        hidden: false,
        meta: { title: "下载中心", noCache: true, allow: false }
      }
    ]
  },
  {
    path: "/goIndex",
    hidden: true,
    meta: { returnFirst: true, allow: false }
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
    meta: { allow: false }
  }
];

if (process.env.NODE_ENV !== "production") {
  const index = constantRoutes.findIndex(item => item.path === "/");
  constantRoutes.splice(index + 1, 0, {
    path: "/template",
    component: Layout,
    redirect: "/template/index",
    hidden: false,
    meta: {
      title: "模版目录",
      icon: "eject-line",
      allow: true
    },
    children: [
      {
        path: "index",
        component: () => import("@/template/index"),
        name: "index",
        hidden: false,
        meta: {
          title: "模版列表",
          noCache: false,
          allow: true
        }
      },
      {
        path: "form",
        component: () => import("@/template/form"),
        name: "form",
        hidden: false,
        meta: {
          title: "模版表单页",
          noCache: false,
          allow: true
        }
      },
      {
        path: "stepForm",
        component: () => import("@/template/stepForm"),
        name: "stepForm",
        hidden: false,
        meta: {
          title: "分段模版表单页",
          noCache: false,
          allow: true
        }
      }
    ]
  });
}

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

const initRouter = () => {
  const router = constantRoutes.map(item => {
    const r = {
      hidden: item.hidden,
      meta: JSON.parse(JSON.stringify(item.meta))
    };
    if (item.children) {
      r.children = item.children.map(i => {
        return { hidden: i.hidden, meta: JSON.parse(JSON.stringify(i.meta)) };
      });
    }
    return r;
  });
  return router;
};

export const constant = initRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
